<template>
  <v-container id="instructions">
    <h1>Template syntax</h1>
    <p>
      The template system is based on tags in a document (docx). These tags are associated to the variable names that are available on the product, ingredients, etc. 
      <br/>See “Apif objects” for available variables and information.
    </p>

    <h2>Text Input</h2>
    <p>
      Replaces a single tag with custom text. Preserves the original text style. 
    </p>

    <span class="caption">Example: Text tag</span><br/>
    <code>
      {name}
    </code>

    <h2>Lists and iterations</h2>
    <p>
    You can iterate text, table rows and lists.
    <br/>Requires an opening tag that starts with # and a closing tag that has the same name and starts with /
    </p>

    <span class="caption">Example: List iteration</span><br/>
    <code>
      {#ingredients}{inciName}{category}{/ingredients}
    </code>

    <br/><br/>

    <h1 class="m-t-3">Object definition</h1>

  </v-container>
</template>

<script>
export default {
  data: () => ({}),
}
</script>